import More from 'components/activity/more/main/containers/MoreContainer';
import AccountDetails from 'components/activity/more/accountDetails/containers/AccountDetailsContainer';
import PersonalDetails from 'components/activity/more/personalDetails/containers/PersonalDetailsContainer';
import EditPersonalDetails from 'components/activity/more/editPersonalDetails/containers/EditPersonalDetailsContainer';
import ConsentManagement from 'components/activity/more/consentManagement/ConsentManagement';
import ConsentManagementDetails from 'components/activity/more/consentManagementDetails/ConsentManagementDetails';
import ConsentConfirmationDelete from 'components/activity/more/consentConfirmationDelete/ConsentConfirmationDelete';
import ManageSubscription from 'components/activity/more/manageSubscription/container/ManageSubscriptionContainer';
import CommunicationPreferences from 'components/activity/more/communicationPreferences/containers/CommunicationPreferencesContainer';
import Settings from 'components/activity/more/settings/containers/SettingsContainer';
import ReferAFriend from 'components/activity/more/referAFriend/presentational/ReferAFriend';
import CashbackRewards from 'components/activity/more/cashbackRewards/presentational/CashbackRewards';

const moreRoutes = [
    { path: '', component: More, pageTitle: 'More' },
    {
        path: 'account',
        component: AccountDetails,
        pageTitle: 'Account Details',
    },
    {
        path: 'personal',
        component: PersonalDetails,
        pageTitle: 'Personal Details',
    },
    {
        path: 'open-banking-services',
        component: ConsentManagement,
        pageTitle: 'Consent Management',
    },
    {
        path: 'open-banking-services/details',
        component: ConsentManagementDetails,
        pageTitle: 'Consent Management Details',
    },
    {
        path: 'open-banking-services/delete',
        component: ConsentConfirmationDelete,
        pageTitle: 'Consent Confirmation Delete',
    },
    {
        path: 'personal/edit',
        component: EditPersonalDetails,
        pageTitle: 'Personal Details',
    },
    {
        path: 'manage-subscription',
        component: ManageSubscription,
        pageTitle: 'Subscription',
    },
    {
        path: 'communication-preferences',
        component: CommunicationPreferences,
        pageTitle: 'Communication Preferences',
    },
    { path: 'settings', component: Settings, pageTitle: 'Settings' },
    {
        path: 'refer-a-friend',
        component: ReferAFriend,
        pageTitle: 'Refer a Friend',
    },
    {
        path: 'cashback-rewards',
        component: CashbackRewards,
        pageTitle: 'Cashback Rewards',
    },
];

export default moreRoutes;
